import React, { useState } from 'react';
import '../../../entrydoor.css';

// Collections are fixed per business requirement; no API fetch needed.
const COLLECTIONS = [
    'Decorative Glass',
    'Textured Glass',
    'Wrought Iron',
    'Commodity Glass',
    'Internal Raise & Lower Blinds',
    'Vents',
    'ODL - SDL Bars',
    'Vertical Accent Contemporary PVC/Aluminum',
    'Custom Glass/Cutout Options',
];

const DoorLiteCollection = ({ value = '', onChange, label = 'Lite Collection' }) => {
    const [selected, setSelected] = useState(value);

    const handleChange = (e) => {
        const v = e.target.value;
        setSelected(v);
        onChange(v);
    };

    return (
        <div className="a-container">
            <label htmlFor="DoorLiteCollection">{label}</label>
            <select id="DoorLiteCollection" value={selected} onChange={handleChange}>
                <option value="" disabled hidden>Select Collection</option>
                {COLLECTIONS.map((c) => (
                    <option key={c} value={c}>{c}</option>
                ))}
            </select>
        </div>
    );
};

export default DoorLiteCollection;
